// @flow
import gql from 'graphql-tag'
import type { Address as LegacyAddress } from 'types'

export const ADDRESS_FIELDS_FRAGMENT = gql`
  fragment AddressFields on Address {
    id
    line1
    line2
    city
    state
    postalCode
    country
    latitude
    longitude
  }
`

export type Address = LegacyAddress
